import React from 'react';
import { useMeeting } from '../../data/hooks/meeting/useMeeting';
import RelativeRedirect from '../elements/RelativeRedirect';

function HasMeeting(props) {
    const { eventId, meetingId, alt = '..', children } = props,
        meeting = useMeeting(eventId, meetingId);

    if (!meeting) {
        console.log(`Meeting ${meetingId} not found in event ${eventId}. Redirecting to ${alt}.`);
        return <RelativeRedirect to={alt} />;
    }

    return children;
}

export default HasMeeting;
